import { Link } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { CONTACT } from "../data/site";

export default function MobileActionBar() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-gold/25 bg-ink/95 backdrop-blur-md md:hidden"
      data-testid="mobile-action-bar"
    >
      <a
        href={`tel:${CONTACT.phoneRaw}`}
        data-testid="mobile-bar-call"
        className="flex flex-col items-center gap-1 py-3 text-foreground transition-colors hover:text-gold-light"
      >
        <Phone className="h-5 w-5 text-gold" />
        <span className="text-[10px] font-semibold uppercase tracking-[0.2em]">Call</span>
      </a>
      <a
        href={`https://wa.me/${CONTACT.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-bar-whatsapp"
        className="flex flex-col items-center gap-1 border-x border-gold/15 py-3 text-foreground transition-colors hover:text-gold-light"
      >
        <MessageCircle className="h-5 w-5 text-gold" />
        <span className="text-[10px] font-semibold uppercase tracking-[0.2em]">WhatsApp</span>
      </a>
      <Link
        to="/quote"
        data-testid="mobile-bar-quote"
        className="flex flex-col items-center gap-1 py-3 text-foreground transition-colors hover:text-gold-light"
      >
        <FileText className="h-5 w-5 text-gold" />
        <span className="text-[10px] font-semibold uppercase tracking-[0.2em]">Quote</span>
      </Link>
    </div>
  );
}
